module.exports = __webpack_public_path__ + "img/elevator1.266f0b1b.png";